import request from "@/utils/request";
import {
  createStaticResult,
  getExpertDetail,
  getExpertList,
  getFallbackBannerList,
} from "@/data/siteContent";

export function artBannerList(params) {
  return request
    .get("/web/banner", params, { login: false })
    .then((res) => ({
      ...res,
      data: res.data && res.data.length ? res.data : getFallbackBannerList(params.area),
    }))
    .catch(() => createStaticResult(getFallbackBannerList(params.area)));
}

export function artExpertTankList(params) {
  return createStaticResult(getExpertList(params.classify || 0));
}

export function artExpertTankDetail(id) {
  return createStaticResult(getExpertDetail(id));
}
